<template>
  <InfoLayout
    v-if="!isMobile"
    :current-path="reverseFull({ name: 'legal_case' })"
    :is-policy="false"
  >
    <template #title>
      {{ t('Битва за отзывы', options) }}
    </template>
    <template #content>
      <div class="container">
        <div class="d-flex mb-sm-4 my-4 my-sm-0">
          <a
            :href="`${reverseFull({ name: 'legal_case' })}?page=${context.case_page}#${context.legal_case.id}`"
            class="text-decoration-none"
          >
            <v-icon
              class="mr-2"
              color="primary"
            >
              ui-icon-arrow-back
            </v-icon>
            <span class="primary--text legal-case__link-text">
              {{ t('к списку', options) }}
            </span>
          </a>
        </div>
        <LegalCaseCard
          :legal-case="context.legal_case"
          is-legal-case-item-page
          class="mb-6"
        />
        <div class="d-flex justify-sm-end justify-space-between mb-4 text--primary">
          <a
            v-if="context.previous_case.id"
            :href="reverseFull({ name: 'legal_case_page', args: [context.previous_case.id] })"
            class="text-decoration-none mr-6"
          >
            <v-icon
              class="ml-2"
              color="primary"
            >
              ui-icon-arrow-left
            </v-icon>
            <span class="primary--text legal-case__link-text">
              {{ t('предыдущее', options) }}
            </span>
          </a>
          <a
            :href="reverseFull({ name: 'legal_case_page', args: [context.next_case.id] })"
            class="text-decoration-none"
            :class="{ 'mx-auto': !context.previous_case.id }"
          >
            <span class="primary--text legal-case__link-text">
              {{ t('следующее', options) }}
            </span>
            <v-icon
              class="ml-2"
              color="primary"
            >
              ui-icon-arrow-right
            </v-icon>
          </a>
        </div>
      </div>
    </template>
  </InfoLayout>
  <div
    v-else
    class="container"
  >
    <div class="d-flex mb-sm-4 my-4 my-sm-0">
      <a
        :href="`${reverseFull({ name: 'legal_case' })}?page=${context.case_page}#${context.legal_case.id}`"
        class="text-decoration-none"
      >
        <v-icon
          class="mr-2"
          color="primary"
        >
          ui-icon-arrow-back
        </v-icon>
        <span class="primary--text legal-case__link-text">
          {{ t('к списку', options) }}
        </span>
      </a>
    </div>
    <LegalCaseCard
      :legal-case="context.legal_case"
      is-legal-case-item-page
      class="mb-6"
    />
    <div class="d-flex justify-sm-end justify-space-between mb-4 text--primary">
      <a
        v-if="context.previous_case.id"
        :href="reverseFull({ name: 'legal_case_page', args: [context.previous_case.id] })"
        class="text-decoration-none mr-6"
      >
        <v-icon
          class="ml-2"
          color="primary"
        >
          ui-icon-arrow-left
        </v-icon>
        <span class="primary--text legal-case__link-text">
          {{ t('предыдущее', options) }}
        </span>
      </a>
      <a
        :href="reverseFull({ name: 'legal_case_page', args: [context.next_case.id] })"
        class="text-decoration-none"
        :class="{ 'mx-auto': !context.previous_case.id }"
      >
        <span class="primary--text legal-case__link-text">
          {{ t('следующее', options) }}
        </span>
        <v-icon
          class="ml-2"
          color="primary"
        >
          ui-icon-arrow-right
        </v-icon>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useContextStore, useURLStore } from 'src/store'
import I18NextVue from 'i18next'
import LegalCaseCard from 'src/components/common/LegalCaseCard/components/LegalCaseCard.vue'
import type { ContextStore } from 'src/components/pages/info/legal-case-page/types'
import InfoLayout from 'src/layouts/info-pages/InfoLayout.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { reverseFull } = useURLStore()
const { context }: ContextStore = useContextStore()

const isMobile = context.flavour === 'mobile'
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.legal-case__link-text {
  border-bottom: 1px dashed $ui-kit-primary;
}
</style>
